import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import TrustBar from '../home/components/TrustBar';
import CoreServicesSection from './components/CoreServicesSection';
import WhyChooseUs from '../home/components/WhyChooseUs';
import ServicesProcessSection from './components/ServicesProcessSection';
import ServicesFabricSection from './components/ServicesFabricSection';
import TestimonialsSection from '../home/components/TestimonialsSection';
import ServiceAreasSection from '../home/components/ServiceAreasSection';
import SpecialOfferSection from '../home/components/SpecialOfferSection';
import ServicesFAQSection from './components/ServicesFAQSection';
import CTASection from '../home/components/CTASection';
import CraftsmanshipGallery from './components/CraftsmanshipGallery';

const ServicesPage = () => {
  useEffect(() => {
    document.title =
      'Custom Tailoring Services | Bespoke Suits, Shirts & Alterations | Custom Clothiers Wellesley MA';
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ServicesHero />
        <TrustBar />
        <CoreServicesSection />
        <WhyChooseUs />
        <ServicesProcessSection />
        <ServicesFabricSection />
        <TestimonialsSection />
        <ServiceAreasSection />
        <SpecialOfferSection />
        <ServicesFAQSection />
        <CTASection />
        <CraftsmanshipGallery />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;
